"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isActionBarChatButton = isActionBarChatButton;
exports.isActionBarFormButton = isActionBarFormButton;
exports.isActionBarScheduleButton = isActionBarScheduleButton;
exports.isActionBarPhoneButton = isActionBarPhoneButton;
exports.isActionBarUrlButton = isActionBarUrlButton;
exports.isActionBarEmailButton = isActionBarEmailButton;
exports.isActionBarHelpButton = isActionBarHelpButton;
exports.isActionBarPaymentButton = isActionBarPaymentButton;
/**
 * Type guard for ActionBarChatButton
 */
function isActionBarChatButton(button) {
    return button.type === "chat";
}
/**
 * Type guard for ActionBarFormButton
 */
function isActionBarFormButton(button) {
    return button.type === "form";
}
/**
 * Type guard for ActionBarScheduleButton
 */
function isActionBarScheduleButton(button) {
    return button.type === "schedule";
}
/**
 * Type guard for ActionBarPhoneButton
 */
function isActionBarPhoneButton(button) {
    return button.type === "phone";
}
/**
 * Type guard for ActionBarUrlButton
 */
function isActionBarUrlButton(button) {
    return button.type === "url";
}
/**
 * Type guard for ActionBarEmailButton
 */
function isActionBarEmailButton(button) {
    return button.type === "email";
}
/**
 * Type guard for ActionBarHelpButton
 */
function isActionBarHelpButton(button) {
    return button.type === "help";
}
/**
 * Type guard for ActionBarPaymentButton
 */
function isActionBarPaymentButton(button) {
    return button.type === "payment";
}
//# sourceMappingURL=ActionBar.js.map